import graphQLAdapter from "@/adapters/graphQL.adapter.js";
import Message from "@/entities/message.entity.js";

/**
 * Message Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.getMessages = getMessages.bind(this);
    this.messageCreate = messageCreate.bind(this);
    this.messageCancel = messageCancel.bind(this);
    this.messageDelete = messageDelete.bind(this);
    this.messageRead = messageRead.bind(this);
    this.getLatestMessages = getLatestMessages.bind(this);
  }
  /**
   * Get the list of messages
   *
   * @static
   * @returns {Promise<Object|null>} Promise object represents the list of messages
   */
  async list (option) {
    await this.adapter.init();
    const res = await this.getMessages(option);
    const updatedEntities = Promise.all(
      // eslint-disable-next-line
      res.data.messages.map(async el => await Message.fromJson(el))
    );
    return updatedEntities;
  }
  async create (option) {
    await this.adapter.init();
    return this.messageCreate(option);
  }

  /**
   * [delete description]
   * @param   {[type]}  option  [option description]
   * @return  {[type]}          [return description]
   */
  async delete (option) {
    await this.adapter.init();
    return this.messageDelete(option);
  }

  /**
   * [cancel description]
   * @param   {[type]}  option  [option description]
   * @return  {[type]}          [return description]
   */
  async cancel (option) {
    await this.adapter.init();
    return this.messageCancel(option);
  }

  /**
   * Change message.isUnread flag
   * @param   {object}  option  [option description]
   * @return  {Promise<Object|null>}          [return description]
   */
  async read (option) {
    await this.adapter.init();
    return this.messageRead(option);
  }
  /**
   * Get the list of latest messages
   *
   * @static
   * @returns {Promise<Object|null>} Promise object represents the list of messages
   */
  async latestMessageList (option) {
    await this.adapter.init();
    const res = await this.getLatestMessages(option);
    return res.data.latestMessages;
  }
}

function getMessages (options = { orderId: null }) {
  const query = `query($orderId: ID!){
    messages(orderId: $orderId) {
      id
      from {
        id
        role
        name
        role
        avatarImageUrl
      }
      order {
        id
        customer{
          name
        }
        client{
          clientGroups {
            name
          }
        }
        clientGroup {
          name
        }
      }
      body
      files
      images
      isUnread
      isCanceled
      isDeleted
      createdAt
    }
  }`;
  return this.adapter.query(query, options);
}
function getLatestMessages (options) {
  const query = `query ($first: Int, $last: Int, $after: String, $before: String) {
    latestMessages(first: $first, last: $last, after: $after, before: $before) {
      edges {
        node {
          id
            from {
              id
              name
              avatarImageUrl
            }
            order {
              id
              customer{
                name
              }
              client{
                clientGroups {
                  name
                }
              }

            }
            body
            files
            images
            isUnread
            createdAt
          }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }`;
  return this.adapter.query(query, options);
}

function messageCreate (options = {}) {
  const mutation = `mutation ($fromUserId: String,$orderId: String,$body: String,$files: [String],$images: [String]){
    messageCreate(message: { fromUserId: $fromUserId, orderId: $orderId, body: $body,files: $files,images: $images }) {
      id
      from {
        id
        name
        avatarImageUrl
      }
      order {
        id
      }
      body
      files
      images
      isUnread
      isCanceled
      isDeleted
      createdAt
    }
  }
  `;
  return this.adapter.mutation(mutation, options);
}

function messageCancel (options = {}) {
  const mutation = `mutation ($id: ID!){
    messageCancel(messageId: $id){
      id
      from {
        id
        name
        avatarImageUrl
      }
      order {
        id
      }
      body
      files
      images
      isUnread
      isCanceled
      isDeleted
      createdAt
    }
  }
  `;

  return this.adapter.mutation(mutation, options);
}

function messageDelete (options = {}) {
  const mutation = `mutation ($id: ID!){
    messageDelete(messageId: $id){
      id
      from {
        id
        name
        avatarImageUrl
      }
      order {
        id
      }
      body
      files
      images
      isUnread
      isCanceled
      isDeleted
      createdAt
    }
  }
  `;

  return this.adapter.mutation(mutation, options);
}

function messageRead (options) {
  const mutation = `mutation ($id: ID!){
    messageRead(messageId: $id){
      id
      from {
        id
      }
      order {
        id
      }
      body
      images
      files
      isUnread
      isCanceled
      isDeleted
      createdAt
    }
  }
  `;
  return this.adapter.mutation(mutation, options);
}
